var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 "},[_c('h6',{staticClass:"mb-2"},[_vm._v("Gas")]),_c('p',{staticClass:"m-0 mb-1"},[_c('strong',[_vm._v(" GPRN: "+_vm._s(_vm.gasAccountInfo.meterPointNumber)+" ")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }